/**
 * 楼层分区管理
 */
import { Button, Col, Icon, Row, Select, Tooltip } from 'antd';
import React from 'react';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import PageLayout from '../../ui/PageLayout';
import FloorEdit from './FloorEdit';
import { global_data } from '../../ui/auth'


class FloorIndex extends React.Component {

    columns = [{
        title: '所属建筑',
        dataIndex: 'buildingName',
        width: '10%',
    }, {
        title: '楼层编码',
        dataIndex: 'floorCode',
        width: '10%',
    }, {
        title: '楼层名称',
        dataIndex: 'floorName',
        width: '10%',
    }, {
        title: '楼层面积',
        dataIndex: 'area',
        width: '10%',
    }, {
        title: '显示顺序',
        dataIndex: 'sequence',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("FLOOR_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("FLOOR_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        buildingList: [],
    };

    componentDidMount() {
        http.post({
            url: '/floor/findBuilding',
            success: (res) => {
                this.setState({ buildingList: res == null ? [] : res });
            }
        });
    }


    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        this.setState({ visible: true });
    }

    update = (info, e) => {
        info["address"] = [info.province, info.city, info.zone];
        this.setState({ editData: info, visible: true });
    }

    delete = (info, e) => {
        messager.confirm("是否删除该楼层及下属铺位？", () => {
            http.post({
                url: '/floor/deleteFloor',
                data: { id: info.id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.buildingName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (field, value, e) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Select placeholder="市场" style={{ width: 200 }} allowClear={true} onChange={this.selectChange.bind(this, "buildingId")}>
                                    {this.state.buildingList.map((item, index) => 
                                        <Select.Option key={item.id}>{item.buildingName}</Select.Option>
                                    )}
                                </Select>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("FLOOR_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/floor/findFloorPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <FloorEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    buildingList={this.state.buildingList}
                />
            </div>
        )
    }
}

export default FloorIndex;